"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _history = require("../../utils/history");

var _CanonicalLink = _interopRequireDefault(require("ecosystem-marketplace-core/components/elements/CanonicalLink"));

var CanonicalLink = function CanonicalLink(_ref) {
  var rel = _ref.rel,
      to = _ref.to;
  return _react.default.createElement(_CanonicalLink.default, {
    rel: rel,
    href: (0, _history.getFullHref)(to).replace(/\/$/, '')
  });
};

CanonicalLink.propTypes = {
  rel: _CanonicalLink.default.propTypes.rel,
  to: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]).isRequired
};
CanonicalLink.defaultProps = {
  rel: 'canonical'
};
var _default = CanonicalLink;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/elements/CanonicalLink.js
// module id = 277
// module chunks = 209 210 211 212